import { SimpleDialog } from "@powerdiary/components-library/lib";
import { useState } from "react";
import { LoginDialogMode, RegisterMode } from "../Account.types";
import LoginDialogForm from "./LoginDialogForm";
import RegisterDialogForm from "./RegisterDialogForm";
import ResetPasswordForm from "./ResetPasswordForm";
import { useMediaQuery, useTheme } from "@mui/material";

interface ILoginDialogProps {
    handleClose: () => void;
    returnUrl: string;
    dialogMode?: LoginDialogMode;
}

export default function LoginDialog({
    handleClose,
    returnUrl,
    dialogMode = LoginDialogMode.Login,
}: Readonly<ILoginDialogProps>) {
    const [mode, setMode] = useState<LoginDialogMode>(dialogMode);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const getDialogTitle = () => {
        if (mode === LoginDialogMode.Login) return "Log in";

        if (mode === LoginDialogMode.Recover) return "Reset Password";

        return "Register";
    };

    return (
        <SimpleDialog
            dataTestIdSuffix="login"
            open
            dialogTitleText={getDialogTitle()}
            handleClose={handleClose}
            paperProps={{
                sx: {
                    minWidth: isMobile ? "calc(100% - 4px)" : "500px",
                    maxWidth: "500px",
                },
            }}
            renderContent={() => {
                switch (mode) {
                    case LoginDialogMode.Login:
                        return <LoginDialogForm returnUrl={returnUrl} loginSuccess={handleClose} setMode={setMode} />;
                    case LoginDialogMode.Recover:
                        return <ResetPasswordForm setMode={setMode} />;
                    case LoginDialogMode.Register:
                        return (
                            <RegisterDialogForm
                                registerCompleted={handleClose}
                                registerMode={RegisterMode.Create}
                                setMode={setMode}
                            />
                        );
                }
            }}
        />
    );
}
